import { Check, Loader2, RotateCcw, Save } from "lucide-react";
import { PdfButton, SheetPreview, VersionTabs } from "@/components/WorkViewer";

const btnLine = "inline-flex items-center gap-2 h-11 px-4 border border-zinc-300 text-sm font-medium hover:border-zinc-950 disabled:opacity-40 transition-colors duration-150";

const LOADING_TEXT = {
  a: ["Sintesi della mappa in corso…", "Qualche secondo"],
  b: ["Sintesi XL in corso…", "Qualche secondo"],
  c: ["Il mangaka AI sta disegnando le vignette…", "Sceneggiatura + 4 illustrazioni · circa 30-60 secondi"],
};

const VersionLoading = ({ ver }) => (
  <div className="border border-zinc-200 bg-white grid place-items-center text-center py-24 px-6" data-testid={`version-loading-${ver}`}>
    <div>
      <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-[#0D9488]" />
      <p className="font-display text-xl font-bold">{LOADING_TEXT[ver][0]}</p>
      <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mt-2">{LOADING_TEXT[ver][1]}</p>
    </div>
  </div>
);

const saveLabel = (saved, workId) => (saved ? "Salvato in Archivio" : workId ? "Aggiorna Archivio" : "Salva in Archivio");

export const StepResult = ({ work, sv, onEdit, onRegenerate, onSelect, onSave }) => {
  const { ver, loading, saved, workId, versions } = sv;
  const ready = !!versions[ver];
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-4 bg-white border border-zinc-200 p-5" data-testid="step-4-export-actions">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Fase 03 / 04</p>
          <p className="font-display text-xl font-bold tracking-tight" data-testid="mindmap-title">{work.title}</p>
        </div>
        <div className="flex flex-wrap gap-3">
          <button data-testid="back-to-step2-btn" onClick={onEdit} className={btnLine}>Modifica testo</button>
          <button data-testid="btn-regenerate-mindmap" onClick={onRegenerate} disabled={loading[ver]} className={btnLine}>
            {loading[ver] ? <Loader2 className="w-4 h-4 animate-spin" /> : <RotateCcw className="w-4 h-4" />} Rigenera {ver.toUpperCase()}
          </button>
          {ready && <PdfButton work={work} version={ver} />}
          <button data-testid="btn-save-archive" onClick={onSave} disabled={loading.save || saved} className="inline-flex items-center gap-2 h-11 px-5 bg-[#0D9488] text-white text-sm font-semibold hover:bg-[#059669] disabled:opacity-60 transition-colors duration-150">
            {saved ? <Check className="w-4 h-4" /> : <Save className="w-4 h-4" />} {saveLabel(saved, workId)}
          </button>
        </div>
      </div>
      <VersionTabs work={work} active={ver} onSelect={onSelect} loading={loading} />
      {ready ? <SheetPreview key={ver} work={work} version={ver} /> : <VersionLoading ver={ver} />}
    </div>
  );
};
